import ImageLoader from './ImageLoader';

export const ImageLoaderSingleton = (() => {
  return new ImageLoader({});
})();
